module.exports = __webpack_public_path__ + "img/reports.e0665c85.jpg";